/* eslint-disable-next-line */
export const getStoryblokRichTextAsPlainText = (richtext: any): string => {
  if (!richtext) return '';
  if (typeof richtext === 'string') return richtext;

  if (Array.isArray(richtext)) {
    return richtext.map(getStoryblokRichTextAsPlainText).join('');
  }

  if (richtext.props?.children) {
    return getStoryblokRichTextAsPlainText(richtext.props.children);
  }

  return '';
};
